export default __webpack_public_path__ + "static/media/logo.d735a3a9.webp";